/* eslint-disable eqeqeq */
import { useCallback, useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { API } from "aws-amplify";
import { DataGrid } from "@mui/x-data-grid";
import { Alert, Typography } from "@mui/material";
import CohortForm from "../CohortForm/CohortForm";
import { updateCohort } from "../../graphql/mutations";
import "./cohortDataGrid.scss";

const propTypes = {
  cohorts: PropTypes.arrayOf(PropTypes.any).isRequired,
  updateCohortsStates: PropTypes.func.isRequired,
};

const CohortDataGrid = ({ cohorts, updateCohortsStates }) => {
  const [pageSize, setPageSize] = useState(5);
  const [rows, setRows] = useState([]);
  const [editRowsModel, setEditRowsModel] = useState({});
  const [alert, setAlert] = useState("");

  useEffect(() => {
    setRows(cohorts);
  }, [cohorts]);

  const handleEditRowsModelChange = useCallback((model) => {
    setEditRowsModel(model);
  }, []);

  const handleRowEditCommit = async (id) => {
    setAlert("");
    const rowValue = editRowsModel[id];
    if (rowValue) {
      const currentValue = rows.find((cohort) => cohort.id === id);
      if (
        currentValue.name === rowValue.name.value &&
        currentValue.year == rowValue.year.value
      ) {
        return;
      }

      const input = {
        id,
        name: rowValue.name.value,
        year: rowValue.year.value,
      };
      try {
        let returnedCohort = await API.graphql({
          query: updateCohort,
          variables: { input },
        });
        returnedCohort = returnedCohort?.data?.updateCohort;
        if (returnedCohort) {
          updateCohortsStates(returnedCohort);
        }
      } catch (e) {
        setAlert("Failed to save. Try again.");
      }
    }
  };

  return (
    <div className="cohort-data">
      <Typography variant="h6" color="primary" className="title">
        Update Cohorts
      </Typography>
      {alert && <Alert severity="error">{alert}</Alert>}
      <Typography variant="subtitle2">Double click to edit</Typography>
      <div className="cohort-grid">
        <DataGrid
          disableSelectionOnClick
          editMode="row"
          autoHeight
          columns={[
            { field: "name", headerName: "Name", flex: 1, editable: true },
            { field: "year", headerName: "Year", width: 150, editable: true },
          ]}
          rows={rows}
          pageSize={pageSize}
          rowsPerPageOptions={[5, 10, 20]}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          editRowsModel={editRowsModel}
          onEditRowsModelChange={handleEditRowsModelChange}
          onRowEditCommit={handleRowEditCommit}
        />
      </div>
      <CohortForm
        setAlert={setAlert}
        updateCohortsStates={updateCohortsStates}
      />
    </div>
  );
};

CohortDataGrid.propTypes = propTypes;

export default CohortDataGrid;
